var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Survey',{attrs:{"surveyId":_vm.surveyId,"surveyQuestions":_vm.surveyQuestions,"surveyTypeQuiz":_vm.surveyTypeQuiz,"totalSteps":_vm.totalSteps,"currentStep":_vm.currentStep},on:{"getEventSurvey":_vm.updatePage}})}
var staticRenderFns = []

export { render, staticRenderFns }